import * as React from 'react';
import { TechtimeTimelineItem } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import * as styles from './lecture-item.module.scss';

type Props = {
  item: TechtimeTimelineItem;
  displayNumber: number;
};

const LectureItem: React.FC<Props> = ({ item, displayNumber }) => (
  <li className={styles.lecture}>
    <div className={styles.description}>
      <FormattedMessage message={item.label} />
      <span>&nbsp;{displayNumber}</span>
    </div>
    <div className={styles.info}>
      <span className={styles.title}>
        <FormattedMessage message={item.title} />
      </span>
      <FormattedMessage className={styles.period} message={item.startDate} />
    </div>
  </li>
);

export { LectureItem };
